import {http} from "../utils/http";
import {Response} from '../types/resp';
export const depositWithdraw = {
	getBankDeposit: async (payload: any) => {
		return http.post<Response<any>>('/get-bank-deposit', payload)
	},

	getAllServiceAskmepay: async (payload: any) => {
		return http.post<Response<any>>('/get-all-service-askmepay', payload)
	},

	getExchangeRate: async (payload: any) => {
		return http.post<Response<any>>('/get-exchange-rate', payload)
	},

	getQrcodeAskmepay: async (payload: any) => {
		return http.post<Response<any>>('/gen-qrcode-askmepay', payload)
	},

	getDecimalDepositInfo: async (payload: any) => {
		return http.post<Response<any>>('/get-decimal-deposit-info', payload)
	},

	createDecimalDepositTrans: async (payload: any) => {
		return http.post<Response<any>>('/create-decimal-deposit-trans', payload)
	},

	getDecimalDepositTrans: async (payload: any) => {
		return http.post<Response<any>>('/get-decimal-deposit-trans', payload)
	},

	checkConditionWithdraw: async () => {
		return http.post<Response<any>>('/check-condition-withdraw', {data:null})
	},

	withdraw: async (payload: any) => {
		return http.post<Response<any>>('/withdraw', payload)
	},

	getPlayerTransaction: async (payload: any) => {
		return http.post<Response<any>>('/get-player-transaction', payload)
	},

	getMinMaxAskmepay: async (payload: any) => {
		return http.post<Response<any>>('/get-min-max-askmepay', payload)
	},

	// AutoPeer
	autoPeerDepositPending: async (payload: any) => {
		return http.post<Response<any>>('/p2c/deposit-pending', payload)
	},

	autoPeerDeposit: async (payload: any) => {
		return http.post<Response<any>>('/p2c/deposit', payload)
	},

	autoPeerDepositStatus: async (payload: any) => {
		return http.post<Response<any>>('/p2c/deposit-status', payload)
	},

	autoPeerUploadSlip: async (payload: any) => {
		return http.post<Response<any>>('/p2c/upload-slip', payload)
	},

	autoPeerForceComplete: async (payload: any) => {
		return http.post<Response<any>>('/p2c/force-complete-transfer', payload)
	},

	autoPeerCancelTransfer: async (payload: any) => {
		return http.post<Response<any>>('/p2c/request-cancel-transfer', payload)
	},
}
